package com.dignicate.web.theme

import com.dignicate.web.domain.Language
import kotlinx.browser.window

private const val KEY_THEME = "app.theme" // "System" | "Light" | "Dark"
private const val KEY_LANG  = "app.lang"  // stored as language.code like "en"/"ja"/"system" or other

// Keys for new Animated Header settings
private const val KEY_HEADER_ANIM_ENABLED   = "app.headerAnimation.enabled"
private const val KEY_HEADER_ANIM_SPEED     = "app.headerAnimation.speed"
private const val KEY_HEADER_ANIM_INTENSITY = "app.headerAnimation.intensity"
private const val KEY_FONT_SCALE = "app.fontScale"

fun loadSettings(): Settings {
    val t = window.localStorage.getItem(KEY_THEME)
    val l = window.localStorage.getItem(KEY_LANG)

    val theme = try { if (t != null) ThemeMode.valueOf(t) else ThemeMode.System }
    catch (_: IllegalArgumentException) { ThemeMode.System }

    val lang  = try { if (l != null) Language.fromCode(l) else Language.System }
    catch (_: IllegalArgumentException) { Language.System }

    // load new header animation settings with safe parsing and defaults
    val enabledStr = window.localStorage.getItem(KEY_HEADER_ANIM_ENABLED)
    val enabled = when (enabledStr) {
        "true" -> true
        "false" -> false
        else -> true // default per spec
    }

    val speedStr = window.localStorage.getItem(KEY_HEADER_ANIM_SPEED)
    val speed = try { speedStr?.toFloat() ?: 0.6f } catch (_: Throwable) { 0.6f }

    val intensityStr = window.localStorage.getItem(KEY_HEADER_ANIM_INTENSITY)
    val intensity = try { intensityStr?.toFloat() ?: 0.75f } catch (_: Throwable) { 0.75f }

    val fontScaleStr = window.localStorage.getItem(KEY_FONT_SCALE)
    val fontScale = try { fontScaleStr?.toFloat() ?: 1.0f } catch (_: Throwable) { 1.0f }

    return Settings(
        theme = theme,
        language = lang,
        fontScale = fontScale,
        headerAnimationEnabled = enabled,
        headerAnimationSpeed = speed,
        headerAnimationIntensity = intensity
    )
}

fun saveSettings(s: Settings) {
    window.localStorage.setItem(KEY_THEME, s.theme.name)
    window.localStorage.setItem(KEY_LANG,  s.language.code)

    // persist new header animation settings
    window.localStorage.setItem(KEY_HEADER_ANIM_ENABLED,   s.headerAnimationEnabled.toString())
    window.localStorage.setItem(KEY_HEADER_ANIM_SPEED,     s.headerAnimationSpeed.toString())
    window.localStorage.setItem(KEY_HEADER_ANIM_INTENSITY, s.headerAnimationIntensity.toString())

    // persist font scale
    window.localStorage.setItem(KEY_FONT_SCALE, s.fontScale.toString())
}
